// @flow
import React, { Component } from "react";

import LicenceList from "../licences/LicenceList";
import { buildLicenceItemJson } from "./CompileCompanytoJson";
import CompanyList from "../../containers/companies/CompanyList";
import FacebaseList from "../facebases/FacebaseList";
import { StyledTabs, NoItem } from "imagus-components";
import UserList from "../../components/users/UserList";

import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";

const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 0,
    paddingBottom: theme.spacing.unit * 5,
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
  }),
});

class CompanyTree extends Component<*> {

  render(): * {
    const classes = this.props.classes;

    const licences = this.props.licences;
    let licenceNode = <span></span>;
    if (licences) {
      if (licences.length === 0) {
        licenceNode = <NoItem content={"The company does not have a licence." + (this.props.canEdit ? " Please click on the \"CREATE LICENCE\" button to create one." : "")} />;
      }
      else {
        let licenceList = [];
        for (let i = 0; i < licences.length; i++) {
          licenceList.push(buildLicenceItemJson(licences[i]));
        }
        licenceNode = <LicenceList licences={licenceList} canEdit={this.props.canEdit} />;
      }
    }

    const children = this.props.children;
    let childrenNode = <span></span>;
    if (children) {
      if (children.length === 0) {
        childrenNode = <NoItem content={"This company do not have any Resellers or End Users." + (this.props.canEdit ? " Please click on the \"CREATE COMPANY\" button to create a new one." : "")} />;
      }
      else {
        childrenNode = <CompanyList children={children} loadChildCompany={this.props.loadChildCompany} />;
      }
    }

    const facebases = this.props.facebases;
    let facebasesNode = <span></span>;
    if (facebases) {
      if (facebases.length === 0) {
        facebasesNode = <NoItem content={"This company does not have any systems." + (this.props.canEdit ? " Please click on the \"CREATE SYSTEM\? button to create a new one." : ".")} />;
      }
      else {
        facebasesNode = <FacebaseList facebases={facebases} company={this.props.company} />;
      }
    }

    const users = this.props.users;
    let userNode = <span></span>;
    if (users) {
      if (users.length === 0) {
        userNode = <NoItem content={"This company does not have any users." + (this.props.canEdit ? " Please click on the \"CREATE USER\" button to create a new one." : ".")} />;
      }
      else {
        userNode = <UserList users={users} />;
      }
    }

    const tabs = [
      { label: "Companies", component: <Paper className={classes.paper}>{childrenNode}</Paper> },
      { label: "Licences", component: <Paper className={classes.paper}>{licenceNode}</Paper> },
      { label: "Systems", component: <Paper className={classes.paper}>{facebasesNode}</Paper> },
      { label: "Users", component: <Paper className={classes.paper}>{userNode}</Paper> }
    ];
    return (
      <div className="app-panel-content panel-top-margin">
        <Divider />
        <StyledTabs tabs={tabs} />
      </div>
    );
  }
}

export default withStyles(styles)(CompanyTree);
